import * as types from '@/store/mutation-types';
import businesses from '@/api/businesses';
import platforms from '@/api/platforms';
import accounts from '@/api/accounts';
import users from '@/api/user';

const state = {
  platforms: [
    {
      id: null
    }
  ],
  selected: {
    id: null,
    logo: null,
    users: [
      {
        id: null
      }
    ]
  }
};

const getters = {
  PlatformsList: state => state.platforms,
  SelectedPlatform: state => state.selected
};

const actions = {
  getPlatformsList({ commit, dispatch }) {
    platforms
      .getPlatformsList()
      .then(platforms => {
        commit(types.SET_PLATFORMS_LIST, platforms.data);
        dispatch('selectPlatform', platforms.data[0].id);
      })
      .catch(error => console.error(error));
  },
  selectPlatform({ commit }, id) {
    platforms.getPlatform(id).then(platform => commit(types.SET_SELECTED_PLATFORM, platform.data));
  },
  updatePlatform({ commit, dispatch }, { id, updates }) {
    businesses.update(id, updates).then(() => {
      dispatch('addNotification', {
        text: 'Platform details have been updated',
        bottom: true,
        left: true,
        colour: 'success'
      });
      platforms.getPlatform(id).then(platform => commit(types.SET_SELECTED_PLATFORM, platform.data));
    });
  },
  updatePlatformUser({ dispatch, state }, { id, updates }) {
    const platformId = state.selected.id;
    return new Promise((resolve, reject) => {
      users
        .updateUser(id, updates)
        .then(() => {
          dispatch('selectPlatform', platformId);
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  sendPlatformWelcomeMessage({ dispatch, state }, id) {
    const platformId = state.selected.id;
    return new Promise((resolve, reject) => {
      users
        .sendWelcomeMessage(id)
        .then(() => {
          dispatch('selectPlatform', platformId);
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  addPlatform({ dispatch }, details) {
    return new Promise((resolve, reject) => {
      accounts
        .register(details)
        .then(() => {
          dispatch('getPlatformsList');
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  updatePlatformUserSecurityRole({ dispatch }, { id, updates }) {
    users.updateSecurityRole({ id, updates }).then(() => {
      dispatch('addNotification', {
        text: 'User permissions have been updated',
        bottom: true,
        left: true,
        colour: 'success'
      });
      // commit(types.UPDATE_SELECTED_ACCOUNT_USER, user.data)
    });
  }
};

const mutations = {
  [types.SET_PLATFORMS_LIST](state, platforms) {
    state.platforms = platforms;
  },
  [types.SET_SELECTED_PLATFORM](state, platform) {
    state.selected = platform;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
